import { render } from "./EmomSetup.vue?vue&type=template&id=a7d0b1e2&scoped=true"
import script from "./EmomSetup.vue?vue&type=script&lang=js"
export * from "./EmomSetup.vue?vue&type=script&lang=js"

import "./EmomSetup.vue?vue&type=style&index=0&id=a7d0b1e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7d0b1e2"]])

export default __exports__